import { Box } from '@mui/material';

function TabPanel(props: any) {
  const {
    children,
    value,
    index,
    padding = 3,
    paddingTop = 3,
    ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: padding, pt: paddingTop }}>{children}</Box>
      )}
    </div>
  );
}

export default TabPanel;

export function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
